export default "/fonts/vendor/balm-ui/material-icons-sharp.woff2?3a0d3ee832500dda50c538f0b34338f9";